export const rolesSelector = state => state.usersAndPermissions.roles.roles;
export const settingsSelector = state => state.usersAndPermissions.roles.settings;
export const userRolesSelector = state => state.usersAndPermissions.roles.userRoles;
